var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCadeado(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#FFF5F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5833 26.1667C22.4578 26.1667 23.1667 25.4578 23.1667 24.5833C23.1667 23.7089 22.4578 23 21.5833 23C20.7089 23 20 23.7089 20 24.5833C20 25.4578 20.7089 26.1667 21.5833 26.1667Z",
    fill: "#D91F05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6471 18.7059H27.3C27.3733 18.3448 27.4118 17.971 27.4118 17.5882C27.4118 14.5019 24.9099 12 21.8236 12C19.3261 12 17.2113 13.6383 16.4952 15.8988L17.3696 16.4817C17.8647 14.4822 19.671 13 21.8236 13C24.3576 13 26.4118 15.0542 26.4118 17.5882C26.4118 17.9738 26.3642 18.3482 26.2747 18.7059H16C14.8954 18.7059 14 19.6014 14 20.7059V29C14 30.1046 14.8954 31 16 31H27.6471C28.7516 31 29.6471 30.1046 29.6471 29.0001V20.7059C29.6471 19.6014 28.7516 18.7059 27.6471 18.7059ZM27.6471 19.7059H16C15.4477 19.7059 15 20.1536 15 20.7059V29C15 29.5523 15.4477 30 16 30H27.6471C28.1993 30 28.6471 29.5523 28.6471 29.0001V20.7059C28.6471 20.1536 28.1993 19.7059 27.6471 19.7059Z",
    fill: "#D91F05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCadeado);
export default __webpack_public_path__ + "static/media/cadeado.c6bbfb75ea4f7546ab843a820cbcce40.svg";
export { ForwardRef as ReactComponent };